import styled from 'styled-components';

import { ContentBanner } from '@xingternal/banner';
import { mediaConfined } from '@xingternal/layout-tokens';
import { space3XL, spaceL, spaceS, spaceXL, spaceXS, spaceXXL, xdlColorButtonSecondaryHover } from '@xingternal/tokens';
import { BodyCopy as BodyCopyComponent, Headline as HeadlineComponent } from '@xingternal/typography';

export const Banner = styled(ContentBanner)`
  flex-direction: column;
  text-align: center;
  width: auto;
  padding: ${spaceXL} ${spaceL};
  margin-top: ${spaceXXL};

  @media ${mediaConfined} {
    padding: ${spaceXXL} ${space3XL};
  }
`;

export const Headline = styled(HeadlineComponent)`
  margin-bottom: ${spaceXS};
`;

export const BodyCopy = styled(BodyCopyComponent)`
  margin-bottom: ${spaceXL};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spaceXL};
`;

export const FeedbackButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spaceS};
`;

export const FeedbackIconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover + button {
    &:after {
      background-color: ${xdlColorButtonSecondaryHover};
    }
  }
`;
